import { admin as actions } from '../actions'

export const initialState = {
  txLog: {
    page: 0,
    limit: 4,
    log: []
  }
}
